module.exports = "/images/compact-logo.png?1157dcc0bb4b85b8a807985b2c1ef0c7";